export const ASSET_MODEL = 'asset_model';
export const BILLING = 'billing';
export const CORE = 'core';
export const DASHBOARD = 'dashboard';
export const GEOFENCE = 'geofence';
export const MAINTENANCE = 'maintenance';
export const ORGANIZATION = 'organization';
export const PROVISION = 'provision';
export const REMOTE = 'remote';
export const REPORT = 'report';
export const USER = 'user';
export const USER_PERMISSION = 'user_permission';

export const CREATE = 'create';
export const READ = 'read';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const MANAGE = 'manage';

export const NO_PERMISSION = 0;
export const READ_PERMISSION = 1;
export const WRITE_PERMISSION = 2;
export const MANAGE_PERMISSION = 3;

// asset_model
export const ASSET_MODEL_CREATE = `${ASSET_MODEL}:${CREATE}`;
export const ASSET_MODEL_READ = `${ASSET_MODEL}:${READ}`;
export const ASSET_MODEL_UPDATE = `${ASSET_MODEL}:${UPDATE}`;
export const ASSET_MODEL_DELETE = `${ASSET_MODEL}:${DELETE}`;

export const OUTPUTSIGNAL_CREATE = `outputsignals:${CREATE}`;
export const OUTPUTSIGNAL_UPDATE = `outputsignals:${UPDATE}`;
export const OUTPUTSIGNAL_DELETE = `outputsignals:${DELETE}`;

export const RULES_CREATE = `rules:${CREATE}`;
export const RULES_UPDATE = `rules:${UPDATE}`;
export const RULES_DELETE = `rules:${DELETE}`;

export const RULE_CONDITIONS_CREATE = `rule-conditions:${CREATE}`;
export const RULE_CONDITIONS_UPDATE = `rule-conditions:${UPDATE}`;
export const RULE_CONDITIONS_DELETE = `rule-conditions:${DELETE}`;

export const SIGNAL_CARDS_UPDATE = `signal-cards:${UPDATE}`;

export const SIGNAL_COLLECTIONS_CREATE = `signal-collections:${CREATE}`;
export const SIGNAL_COLLECTIONS_UPDATE = `signal-collections:${UPDATE}`;
export const SIGNAL_COLLECTIONS_DELETE = `signal-collections:${DELETE}`;

export const TRANSFORMS_CREATE = `transforms:${CREATE}`;
export const TRANSFORMS_UPDATE = `transforms:${UPDATE}`;
export const TRANSFORMS_DELETE = `transforms:${DELETE}`;

// billing
export const BILLING_WRITE = `${BILLING}:write`;

// core
export const ALERTS_CLEAR = 'alerts:clear';

export const ASSET_CREATE = `asset:${CREATE}`;
export const ASSET_UPDATE = `asset:${UPDATE}`;
export const ASSET_DELETE = `asset:${DELETE}`;

export const CORE_READ = `${CORE}:${READ}`;

export const WATERTRANSFER_CREATE = `watertransfer:${CREATE}`;
export const WATERTRANSFER_UPDATE = `watertransfer:${UPDATE}`;
export const WATERTRANSFER_DELETE = `watertransfer:${DELETE}`;

// dashboard
export const DASHBOARD_CREATE = `${DASHBOARD}:${CREATE}`;
export const DASHBOARD_READ = `${DASHBOARD}:${READ}`;
export const DASHBOARD_UPDATE = `${DASHBOARD}:${UPDATE}`;
export const DASHBOARD_DELETE = `${DASHBOARD}:${DELETE}`;

export const WIDGET_CREATE = `widget:${CREATE}`;
export const WIDGET_UPDATE = `widget:${UPDATE}`;
export const WIDGET_DELETE = `widget:${DELETE}`;

export const WIDGET_GRID_UPDATE = `widget-grid:${UPDATE}`;

// geofence
export const GEOFENCE_CREATE = `${GEOFENCE}:${CREATE}`;
export const GEOFENCE_READ = `${GEOFENCE}:${READ}`;
export const GEOFENCE_UPDATE = `${GEOFENCE}:${UPDATE}`;
export const GEOFENCE_DELETE = `${GEOFENCE}:${DELETE}`;

// maintenance
export const MAINTENANCE_LOG_CREATE = `${MAINTENANCE}-log:${CREATE}`;
export const MAINTENANCE_MANAGE = `${MAINTENANCE}:${MANAGE}`;
export const MAINTENANCE_READ = `${MAINTENANCE}:${READ}`;

export const MAINTENANCE_PARTS_CREATE = `maintenance-parts:${CREATE}`;
export const MAINTENANCE_PARTS_UPDATE = `maintenance-parts:${UPDATE}`;
export const MAINTENANCE_PARTS_DELETE = `maintenance-parts:${DELETE}`;

export const MAINTENANCE_REMINDERS_CREATE = `maintenance-reminders:${CREATE}`;
export const MAINTENANCE_REMINDERS_UPDATE = `maintenance-reminders:${UPDATE}`;
export const MAINTENANCE_REMINDERS_DELETE = `maintenance-reminders:${DELETE}`;

export const MAINTENANCE_SCHEDULES_CREATE = `maintenance-schedules:${CREATE}`;
export const MAINTENANCE_SCHEDULES_UPDATE = `maintenance-schedules:${UPDATE}`;
export const MAINTENANCE_SCHEDULES_DELETE = `maintenance-schedules:${DELETE}`;

// organization
export const ORGANIZATION_CREATE = `${ORGANIZATION}:${CREATE}`;
export const ORGANIZATION_READ = `${ORGANIZATION}:${READ}`;
export const ORGANIZATION_UPDATE = `${ORGANIZATION}:${UPDATE}`;
export const ORGANIZATION_DELETE = `${ORGANIZATION}:${DELETE}`;

export const ORGANIZATION_MOVE = `${ORGANIZATION}:move`;

// provision
export const PROVISION_CREATE = `${PROVISION}:${CREATE}`;
export const PROVISION_READ = `${PROVISION}:${READ}`;
export const PROVISION_UPDATE = `${PROVISION}:${UPDATE}`;
export const PROVISION_DELETE = `${PROVISION}:${DELETE}`;

// remote
export const ASSET_COMMANDS_UPDATE = `asset-commands:${UPDATE}`;

export const GATEWAY_VERSION_UPDATE = `gateway-version:${UPDATE}`;

export const REMOTE_CREATE = `${REMOTE}:${CREATE}`;
export const REMOTE_READ = `${REMOTE}:${READ}`;
export const REMOTE_UPDATE = `${REMOTE}:${UPDATE}`;
export const REMOTE_DELETE = `${REMOTE}:${DELETE}`;

export const REMOTE_EXECUTE = `${REMOTE}:execute`;

export const USER_COMMANDS_UPDATE = `user-commands:${UPDATE}`;

// report
export const FLEET_CREATE = `fleet:${CREATE}`;
export const FLEET_UPDATE = `fleet:${UPDATE}`;
export const FLEET_DELETE = `fleet:${DELETE}`;
export const FLEET_REPORTS = `fleet:reports`;

export const REPORT_CREATE = `${REPORT}:${CREATE}`;
export const REPORT_READ = `${REPORT}:${READ}`;
export const REPORT_UPDATE = `${REPORT}:${UPDATE}`;
export const REPORT_DELETE = `${REPORT}:${DELETE}`;
export const REPORT_SCHEDULE = `${REPORT}:schedule`;

// user
export const NON_PLATFORM_USER_SUBSCRIPTION = `non-platform-${USER}:${UPDATE}`;
export const RULE_SUBSCRIPTION_USERS = `rule-subscription-${USER}:${UPDATE}`;

export const USER_CREATE = `${USER}:${CREATE}`;
export const USER_READ = `${USER}:${READ}`;
export const USER_UPDATE = `${USER}:${UPDATE}`;
export const USER_DELETE = `${USER}:${DELETE}`;

export const USER_PROFILE_CREATE = `user-profile:${CREATE}`;
export const USER_PROFILE_READ = `user-profile:${READ}`;
export const USER_PROFILE_UPDATE = `user-profile:${UPDATE}`;
export const USER_PROFILE_DELETE = `user-profile:${DELETE}`;

// user_permission
export const USER_PERMISSION_CREATE = `${USER_PERMISSION}:${CREATE}`;
export const USER_PERMISSION_READ = `${USER_PERMISSION}:${READ}`;
export const USER_PERMISSION_UPDATE = `${USER_PERMISSION}:${UPDATE}`;
export const USER_PERMISSION_DELETE = `${USER_PERMISSION}:${DELETE}`;
